
import { IGetIndicatorStatusHistoryByDayParameters } from "./IGetIndicatorStatusHistoryByDayParameters";


export class GetIndicatorStatusHistoryByDayParameters implements IGetIndicatorStatusHistoryByDayParameters
{
    componentId: number = 0;
    indicatorId: number = 0;
    date: Date = new Date();
    daysBehind: number = 0;
}
